/* eslint-disable */

export const TagLead = (props: any) => (
  <svg
    width="11"
    height="12"
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0.9375L5.86328 1.06055L0.572266 6.40625L0.873047 6.7207L5.0293 10.877L5.34375 11.1777L10.6895 5.88672L10.8125 5.75V0.9375H6ZM6.36914 1.8125H9.9375V5.38086L5.34375 9.94727L1.80273 6.40625L6.36914 1.8125ZM8.625 2.6875C8.50651 2.6875 8.40169 2.73307 8.31055 2.82422C8.22852 2.90625 8.1875 3.00651 8.1875 3.125C8.1875 3.24349 8.22852 3.34831 8.31055 3.43945C8.40169 3.52148 8.50651 3.5625 8.625 3.5625C8.74349 3.5625 8.84375 3.52148 8.92578 3.43945C9.01693 3.34831 9.0625 3.24349 9.0625 3.125C9.0625 3.00651 9.01693 2.90625 8.92578 2.82422C8.84375 2.73307 8.74349 2.6875 8.625 2.6875Z"
      fill="#424248"
    />
  </svg>
);
